import TeamBadge from './TeamBadge.vue';
export default TeamBadge;
